<template>
    <div v-if="!list.loading">
        <div class="columns is-multiline">
            <space-create class="column is-4-desktop is-3-fullhd is-6-tablet"/>

            <div v-for="space in list.data.results || []"
                class="column is-4-desktop is-3-fullhd is-6-tablet"
                :key="space.id">

                <div class="card space-card">
                    <div class="card-header">
                        <router-link :to="link(space.id)" class="card-header-title">
                            <space-avatar :space="space" class="is-24x24"/> &nbsp;
                            {{ space.name }}
                        </router-link>

                        <a class="card-header-icon">
                            <i class="icon fas fa-ellipsis-v"></i>
                        </a>
                    </div>

                    <div class="card-content">
                        <div v-if="space.description">{{space.description}}</div>
                        <div v-else class="has-text-grey">No description</div>
                    </div>

                    <div class="card-footer has-text-grey">
                        <div class="is-pulled-left">
                            <i class="icon fas fa-user-friends"></i>
                            {{space.members_count}}
                        </div> &nbsp;

                        <role v-for="role in space.roles" :role="role" :key="role"/>

                        <div class="is-pulled-right">
                            <i class="icon fas fa-copy"></i>
                            {{space.notes_count}}
                        </div>
                        <div class="is-clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <base-paginator
            :current="parseInt($route.query.page || 1)"
            :total-count="list.data.count || 0"
            :per-page="15"/>
    </div>

    <div v-else class="loader title"></div>
</template>

<script>
import { mapState } from 'vuex';
import Role from '../common/Role.vue';
import SpaceCreate from './SpaceCreate.vue';
import SpaceAvatar from './SpaceAvatar.vue';

export default {
    name: 'SpaceList',
    components: {
        SpaceAvatar, SpaceCreate, Role,
    },
    computed: mapState('spaces', ['list']),
    created() {
        this.load();
    },
    watch: { $route: 'load' },
    methods: {
        load() {
            this.$store.dispatch('spaces/list', { page: this.$route.query.page || 1 });
        },
        link(space) {
            const last_page = this.$store.state.spaces.last_page[space];
            return last_page || { name: 'content', params: { space } };
        },
    },
};
</script>
